module.exports = __webpack_public_path__ + "app/images/home/photo_jess.png";